import { useState, useEffect } from 'react';
import { Table, Button, Card, Typography, Select, Input, Tag, Checkbox, notification, Spin } from 'antd';
import Swal from 'sweetalert2';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import { BASE_URL } from "../../App";
import './css1.css';

const { Title } = Typography;
const { Option } = Select;
const { Search } = Input;

const BranchDealerForm = () => {
  const [branches, setBranches] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [dealers, setDealers] = useState([]);
  const [filteredDealers, setFilteredDealers] = useState([]);
  const [showInactive, setShowInactive] = useState(false);
  const [loading, setLoading] = useState(false); // For fetching branches & dealers
  const [updatingStatus, setUpdatingStatus] = useState(false); // For updating dealer status
  const login_id = localStorage.getItem("LOGIN_ID");
  const branch = localStorage.getItem("BRANCH_CODE");
  const usertype = localStorage.getItem("usertype");
  //const login_id = "a6H0OWh7Vm9xd6gSRAznZG/2DBaoAfH3uTS3T3DnQ6qQulOba+ffgalsHcb9qHKKXcIHU1gVVXvImo2bwm9oIw==";

  // Fetch branches on component mount
  useEffect(() => {
    fetchBranches();
  }, []);

  const fetchBranches = async () => {
    setLoading(true); // Show loading
    try {
      const response = await axios.post(BASE_URL + '/branchListt', { login_id: login_id, usertype: usertype });
      if (response.data?.status_code === "200") {
        setBranches(response.data.list);
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
    } finally {
      setLoading(false); // Hide loading
    }
  };

  const handleBranchChange = async (values) => {
    setSelectedBranches(values);
    fetchDealers(values);
  };

  const fetchDealers = async (branches) => {
    setLoading(true); // Show loading while fetching dealers
    try {
      const response = await axios.post(BASE_URL + '/getdealerforcontrol', {
        login_id: login_id,
        usertype: usertype,
        branch_code: branches,
        status: showInactive ? "1" : "0"
      });
      if (response.data?.status_code === "200") {
        setDealers(response.data.list);
        setFilteredDealers(response.data.list);
      }
    } catch (error) {
      console.error("Error fetching dealers:", error);
    } finally {
      setLoading(false); // Hide loading
    }
  };

  const handleDealerStatusChange = async (dealerCode, currentStatus) => {
    const newStatus = currentStatus === 'active' ? 0 : 1;
    setUpdatingStatus(true); // Show loader while updating status

    try {
      const response = await axios.post(BASE_URL + '/updateDealerStatus', {
        login_id: login_id,
        branch_codes: selectedBranches,
        dealer_codes: [dealerCode],
        status: newStatus
      });

      if (response.data.status === 'success') {
        const statusText = newStatus === 1 ? 'Activated' : 'Inactivated';
        notification.success({
          message: 'Success',
          description: `Dealer ${dealerCode} ${statusText} Successfully!`,
          placement: 'topRight',
          duration: 2
        });

        // Refresh dealer list after status update
        setTimeout(() => {
          fetchDealers(selectedBranches); 
        }, 500);
      }
    } catch (error) {
      Swal.fire('Error', 'Failed to update dealer status', 'error');
    } finally {
      setUpdatingStatus(false); // Hide loader
    }
  };

  const handleSearch = (value) => {
    const filtered = dealers.filter((dealer) =>
      dealer.code.toLowerCase().includes(value.toLowerCase()) || 
      dealer.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredDealers(filtered);
  };

  const handleCheckboxChange = (e) => {
    if (selectedBranches.length === 0) {
      notification.info({
        message: 'Info',
        description: `Please select a branch!`,
        placement: 'topRight',
        duration: 2
      });  
      return;
    }
    setShowInactive(e.target.checked);
  };
  
  useEffect(() => {
    handleBranchChange(selectedBranches);
  }, [showInactive]);
 

  const columns = [
    {
      title: 'Dealer Code',
      dataIndex: 'code',
      key: 'code',
      width: 130
    },
    {
      title: 'Dealer Name',
      dataIndex: 'name',
      key: 'name',
      width: 200
    },
    {
      title: 'Branch',
      dataIndex: 'branch_code',
      key: 'branch_code',
      width: 100
    },
    {
      title: 'Modified By',
      dataIndex: 'created_by',
      key: 'created_by',
      width: 130
    },
    {
      title: 'Modified On',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 130
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status, record) => (
        <Tag
          color={status === 'active' ? 'success' : 'error'}
          className="status-tag"
          onClick={() => handleDealerStatusChange(record.code, status)}
        >
          {status === 'active' ? (
            <>
              <CheckCircleOutlined style={{ marginRight: 8 }} />
              Active
            </>
          ) : (
            <>
              <CloseCircleOutlined style={{ marginRight: 8 }} />
              Inactive
            </>
          )}
        </Tag>
      )
    }
  ];

  return (
    <div style={{ backgroundColor: '#f0f2f5', minHeight: '100vh', padding: '20px' }}>
      <Card className="branch-dealer-card" style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '20px' }}>
        {/* <Title level={3} className="title">Dealer Status Control</Title> */}

        {/* Branch Selection Dropdown and Checkbox */}
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
          <Select 
            mode="multiple" 
            placeholder="Select Branch" 
            onChange={handleBranchChange} 
            className="select-box"
            style={{ width: '80%' }}
          >
            {login_id && (
              <Option key="ALL" value="ALL">
                ALL
              </Option>
            )}
            {branches.map((branch) => (
              <Option key={branch.code} value={branch.code}>
                {branch.code} - {branch.name}
              </Option>
            ))}
          </Select>
          <Checkbox onChange={handleCheckboxChange}style={{ display: 'flex', alignItems: 'center',marginBottom:'20px'}}>Inactive Dealer</Checkbox>
        </div>

        {/* Search Dealer */}
        <Search 
          placeholder="Search Dealer Code or Dealer Name" 
          onChange={(e) => handleSearch(e.target.value)} 
          className="search-bar"
          allowClear
          style={{ marginBottom: '20px' }}
        />

        {/* Dealer Table with Loading */}
        <Spin spinning={loading || updatingStatus}>
          <Table 
            columns={columns} 
            dataSource={filteredDealers} 
            rowKey="code" 
            pagination={{ pageSize: 20, showSizeChanger: true }} 
            scroll={{ y: 400 }}
          />
        </Spin>
      </Card>
    </div>
  );
};

export default BranchDealerForm;
